import type { ReactNode } from 'react';

import { DimeItemDescription } from './DimeItem.js';
import { cn } from './lib/utils.js';

export type DimeItemDetailLineProps = {
  icon: ReactNode;
  label: string;
  value: string;
  href?: string;
  valueClassName?: string;
  /** Rendered after the value, e.g. a status icon with its own tooltip. */
  adornment?: ReactNode;
  className?: string;
};

export function DimeItemDetailLine({
  icon,
  label,
  value,
  href,
  valueClassName,
  adornment,
  className,
}: DimeItemDetailLineProps) {
  const valueElement = href ? (
    <a
      href={href}
      aria-label={`${label}: ${value}`}
      className={cn('text-primary underline', valueClassName)}
    >
      {value}
    </a>
  ) : (
    <span className={cn('text-primary', valueClassName)}>{value}</span>
  );

  return (
    <DimeItemDescription className={cn('inline-flex items-start gap-1.5', className)}>
      {/* WHY: Inter sets its glyphs about 1px below the line box's middle, so the icon drops 1px to centre on them, and stays by the first line when the text wraps. */}
      <span className="flex h-lh shrink-0 translate-y-px items-center">{icon}</span>
      <span>
        {label}:{' '}
        {adornment ? (
          <span className="whitespace-nowrap">
            {valueElement}
            <span className="ml-1.5 inline-flex align-middle">{adornment}</span>
          </span>
        ) : (
          valueElement
        )}
      </span>
    </DimeItemDescription>
  );
}
